// Case-study image: optional device frame (b.frame: phone / tablet / browser / laptop; decoration only, the image keeps the
// width its Size setting gives it) and click to zoom (the gallery's photo lightbox, PhotoLightbox in PhotoWorkspace.js, with the same opening animation).
// Used by the image and image + text blocks in CaseStudyPage.js.
(function () {
  const { Box, Typography } = MaterialUI;
  const { useState, useEffect, useRef } = React;

  // Device bezel: near-black in both themes, tinted toward the theme's outline
  const BEZEL = 'color-mix(in srgb, var(--m3-scrim) 86%, var(--m3-outline))';
  const FRAMES = {
    phone: { outer: 40, pad: 10, inner: 30 },
    tablet: { outer: 28, pad: 14, inner: 14 },
    laptop: { outer: 14, pad: 12, inner: 3 },
    browser: { outer: 12, pad: 0, inner: 0 }
  };
  const FRAME_TYPES = Object.keys(FRAMES);

  function DeviceFrame({ frame, children }) {
    const f = FRAMES[frame];
    if (!f) return children;
    if (frame === 'browser') {
      return (
        <Box sx={{ borderRadius: `${f.outer}px`, overflow: 'hidden', border: '1px solid var(--m3-outline-variant)', backgroundColor: 'var(--m3-surface-container-high)' }}>
          <Box aria-hidden="true" sx={{ display: 'flex', alignItems: 'center', gap: 0.75, height: 32, px: 1.5 }}>
            {[0, 1, 2].map(i => <Box key={i} sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: 'var(--m3-outline-variant)' }} />)}
            <Box sx={{ flex: 1, maxWidth: 360, height: 18, mx: 'auto', borderRadius: 'var(--m3-shape-full)', backgroundColor: 'var(--m3-surface-container-highest)' }} />
          </Box>
          {children}
        </Box>
      );
    }
    const screen = (
      <Box sx={{ position: 'relative', p: `${f.pad}px`, borderRadius: frame === 'laptop' ? `${f.outer}px ${f.outer}px 0 0` : `${f.outer}px`, backgroundColor: BEZEL, boxShadow: '0 0 0 1px var(--m3-outline-variant), var(--m3-elevation-2)' }}>
        {frame === 'phone' && <Box aria-hidden="true" sx={{ position: 'absolute', top: f.pad + 8, left: '50%', transform: 'translateX(-50%)', width: '28%', height: 18, borderRadius: 'var(--m3-shape-full)', backgroundColor: BEZEL, zIndex: 1 }} />}
        <Box sx={{ borderRadius: `${f.inner}px`, overflow: 'hidden', lineHeight: 0 }}>{children}</Box>
      </Box>
    );
    return (
      <Box>
        {screen}
        {frame === 'laptop' && (
          <Box aria-hidden="true" sx={{ position: 'relative', height: 14, mx: '-6%', borderRadius: '0 0 14px 14px', backgroundColor: 'var(--m3-surface-container-highest)', borderTop: '1px solid var(--m3-outline-variant)', boxShadow: 'var(--m3-elevation-1)' }}>
            <Box sx={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '16%', height: 6, borderRadius: '0 0 8px 8px', backgroundColor: 'var(--m3-outline-variant)' }} />
          </Box>
        )}
      </Box>
    );
  }

  // img: the attributes for <img> (src, srcSet, sizes...); b: the block (u = original upload, c = caption, frame)
  function CaseImage({ img, b, radius = '16px' }) {
    const [zoom, setZoom] = useState(false);
    const framed = !!FRAMES[b.frame];
    return (
      <>
        <DeviceFrame frame={b.frame}>
          <Box component="button" type="button" onClick={() => setZoom(true)} aria-label={b.c ? `Enlarge image: ${b.c}` : 'Enlarge image'}
            sx={{ display: 'block', width: '100%', p: 0, m: 0, border: 0, background: 'none', cursor: 'zoom-in', borderRadius: framed ? 0 : radius,
              '&:focus-visible': { outline: '3px solid var(--m3-secondary)', outlineOffset: 2 } }}>
            <Box component="img" {...img} alt={b.c || ''} loading="lazy" sx={{ width: '100%', height: 'auto', display: 'block', borderRadius: framed ? 0 : radius }} />
          </Box>
        </DeviceFrame>
        {zoom && <window.Components.PhotoLightbox photos={[{ url: b.u, title: b.c || '' }]} index={0} onIndex={() => {}} onClose={() => setZoom(false)} bare />}
      </>
    );
  }

  window.Components = window.Components || {};
  window.Components.CaseImage = CaseImage;
  window.Components.DeviceFrame = DeviceFrame;
  window.CaseImageFrames = FRAME_TYPES;
})();
